import { render } from "./ProductsPage.vue?vue&type=template&id=62fcc629"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"
script.render = render

export default script